<template>
    <v-container fluid class="pa-0 pb-8">
        <v-container fluid>
            <Breadcrumbs :title="$t('modules.portalalumno.payments.paymentsStudents.breadcrumbs.title')" :description="$t('modules.portalalumno.payments.paymentsStudents.breadcrumbs.description')"></Breadcrumbs>
            <v-row justify="center">
                <v-col class="viewSpaces" cols="12">
                    <v-row>
                        <v-col cols="12" :md="(step != 3) ? '7' : '12'" :lg="(step != 3) ? '8' : '12'">
                            <v-stepper v-model="step" class='stepper paymentStepper' :alt-labels="$isMobile">
                                <v-stepper-header class="stepper-header">
                                    <v-stepper-step class="stepper-step" :complete="step > 1" :color="step > 1 ? 'green' : 'primary'" step="1">
                                        {{$t('modules.portalalumno.payments.paymentsStudents.view.stepper.selection')}}
                                    </v-stepper-step>
                                    <v-stepper-step class="stepper-step" :complete="step > 2" :color="step > 2 ? 'green' : 'primary'" step="2" >
                                        {{$t('modules.portalalumno.payments.paymentsStudents.view.stepper.payment')}}
                                    </v-stepper-step>
                                    <v-stepper-step step="3" class="stepper-step">
                                        {{$t('modules.portalalumno.payments.paymentsStudents.view.stepper.confirmation')}}
                                    </v-stepper-step>
                                </v-stepper-header>
                                <v-stepper-items>
                                    <v-stepper-content step="1" class="px-0">

                                        <div v-show="!repayment.selected">
                                            <PaymentsBanner v-if="showBanner" :percentage="extraBenefitPercentage"></PaymentsBanner>

                                            <TeclabReenrollmentBanners
                                                v-if="teclabReenrollment"
                                                :reenrollment="teclabReenrollment"
                                                :hasDebt="hasDebt"
                                                @open-documentation="documentationDrawerOpen = true"
                                            ></TeclabReenrollmentBanners>

                                            <CareerRadioSelector
                                              :title="$t('modules.portalalumno.payments.paymentsStudents.view.labels.selectACareer')"
                                              :items="studentRegisters"
                                              item-text="career"
                                              item-value="legajo"
                                              v-model="selectedRegister"
                                              @change="handleStudentCareerUpdate"
                                            />

                                            <PaymentsSelectionGridView
                                                ref="paymentSelectionGridView"
                                                :systemConfig="systemConfig"
                                                :prepaids="prepaids"
                                                :productWithPricePrepaids="productWithPricePrepaids"
                                                :payments="filteredPaymentsByCountryConstants"
                                                :paymentsNext="filteredPaymentsNextByCountryConstants"
                                                :repayment="repayment"
                                                :generatePaymentIds="generatePaymentIds"
                                                @billingchange="onBillingChange($event.payments, $event.itemsToUpdate)"
                                            ></PaymentsSelectionGridView>
                                        </div>

                                        <Repayment
                                            ref="REP"
                                            v-if="repayment.selected"
                                            :resumen="resumen"
                                            :unselectedReenrollmentsAccountIds="unselectedReenrollmentsAccountIds"
                                            :summaryButtons="summaryButtons"
                                            @continue="onPayClick"
                                        ></Repayment>
                                    </v-stepper-content>

                                    <v-stepper-content step="2">

                                        <PaymentsSelectionView
                                            v-if="step == '2'"
                                            @changeStep="nextStepChange"
                                            :resumen="resumen"
                                        ></PaymentsSelectionView>

                                        <PaymentsDebitView
                                            ref="TD"
                                            v-if="selectedMethod.id == 'TD'"
                                            :resumen="resumen"
                                            :unselectedReenrollmentsAccountIds="unselectedReenrollmentsAccountIds"
                                            :summaryButtons="summaryButtons"
                                            :selectedMethod="selectedMethod"
                                            @goBackPayment="goBackPayment"
                                            @changeStep="nextStepChange"
                                        ></PaymentsDebitView>

                                        <PaymentsCashView
                                            ref="FT"
                                            v-if="selectedMethod.id == 'FT'"
                                            :resumen="resumen"
                                            :unselectedReenrollmentsAccountIds="unselectedReenrollmentsAccountIds"
                                            :coupon="coupon"
                                            :summaryButtons="summaryButtons"
                                            :selectedMethod="selectedMethod"
                                            @goBackPayment="goBackPayment"
                                            @changeStep="nextStepChange"
                                            @updateCouponExternalInfo="updateCouponExternalInfo"
                                        ></PaymentsCashView>

                                        <PaymentsSubscriptionView
                                          ref="SUS"
                                          v-if="selectedMethod.id == 'SUS'"
                                          @goBackPayment="goBackPayment"
                                          @changeStep="nextStepChange"
                                          :subscriptions="filteredSubscriptions"
                                          :subscriptionPaymentTypes="filteredSubscriptionsTypes"
                                          :selectedMethod="selectedMethod"
                                          :reenrollment="teclabReenrollment"
                                          :coupon="coupon"
                                          :resumen="resumen"
                                          :unselectedReenrollmentsAccountIds="unselectedReenrollmentsAccountIds"
                                          :summaryButtons="summaryButtons"
                                          @setDue="setDue"
                                        ></PaymentsSubscriptionView>
                                    </v-stepper-content>

                                    <v-stepper-content step="3">
                                        <PaymentsCompletedView
                                            :resumen="resumen"
                                            :coupon="coupon"
                                            :status="successMessage"
                                        ></PaymentsCompletedView>
                                    </v-stepper-content>
                                </v-stepper-items>
                            </v-stepper>
                        </v-col>
                        <v-col cols="12" md="5" lg="4">
                            <v-card class="mx-6 mx-md-0 margin-bot">
                                <PaymentSummary
                                    v-if="step != 3"
                                    :summaryButtons="summaryButtons"
                                    :resumen="resumen"
                                    :credit-cards="creditCards"
                                ></PaymentSummary>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </v-container>

        <TemporaryRightDrawer
            v-if="teclabReenrollment"
            @tmpDrawerOpen="documentationDrawerOpen = false"
            :open="documentationDrawerOpen"
            :title="$t('modules.portalalumno.payments.paymentsStudents.banners.benefit.upload_title')"
            :description="$t('modules.portalalumno.payments.paymentsStudents.banners.benefit.upload_description')"
        >
            <DocumentationUpload
                v-if="teclabReenrollment.benefit && teclabReenrollment.benefit.documentation && teclabReenrollment.benefit.documentation.length"
                :benefit="teclabReenrollment.benefit"
                @close="closeDocumentationUpload"
            ></DocumentationUpload>
        </TemporaryRightDrawer>

        <v-dialog v-model="showModal" @hide="closeModal" max-width="400px">
    
          <v-card>
            <v-card-title class="headline">Domiciliación bancaria</v-card-title>
            <v-card-text>
              <v-form @submit.prevent="onConfirmDirectDebit">
                <v-row>
                  <v-col cols="12" md="12">
                    <v-text-field
                      v-model="iban"
                      label="IBAN"
                      required
                      :error-messages="modalErrors"
                      @input="clearErrors"
                      outlined
                      :rules="validIban"
                    ></v-text-field>
                  </v-col>
                </v-row>
      
                <v-row class="mt-4">
                  <v-col cols="12" class="text-right">
                    <v-btn type="submit" color="primary" class="mr-2" :loading="loadingDirectDebit">Domiciliar</v-btn>
                    <v-btn @click="closeModal" :disabled="loadingDirectDebit">Regresar</v-btn>
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>
          </v-card>
        </v-dialog>

        <v-dialog v-model="showAgreementModal" @hide="closeAgreementModal" max-width="400px">
          <v-card>
            <v-card-title class="headline">Acuerdos de uso y privacidad</v-card-title>
            <v-card-text>
              <v-form @submit.prevent="onPayClick">
                <v-row>
                  <v-col cols="12" md="12">
                    <div class="d-flex flex-column">
                      <div class="checkConfirm" style="display: flex; align-items: center;">
                          <v-checkbox v-model="acceptTerms">
                          </v-checkbox>
                          <label for="">
                            Acepto los <a href="https://www.cerem.es/terminos-y-condiciones-de-uso/" target="_blank">Términos y condiciones de uso</a>, la <a href="https://www.cerem.es/politica-de-privacidad/" target="_blank">Política de privacidad</a> y el <a href="https://www.cerem.es/reglamento-de-cursado/" target="_blank">Reglamento de cursado</a>
                          </label>
                      </div>
                    </div>
                  </v-col>
                </v-row>

                <v-row class="mt-4">
                  <v-col cols="12" class="text-right">
                    <v-btn type="submit" color="primary" class="mr-2" :disabled="!acceptTerms">Aceptar</v-btn>
                    <v-btn @click="closeAgreementModal">Regresar</v-btn>
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-container>
</template>

<script>
    import Breadcrumbs from '@/components/Breadcrumbs/Breadcrumbs';
    import CareerRadioSelector from '@/components/CareerRadioSelector/CareerRadioSelector';
    import PaymentsSelectionGridView from './PaymentsSelectionGridView'
    import PaymentsCompletedView from './PaymentsCompletedView';
    import PaymentsCashView from './PaymentsCashView';
    import PaymentsDebitView from './PaymentsDebitView';
    import PaymentsSubscriptionView from './PaymentsSubscriptionView.vue';
    import PaymentsSelectionView from './PaymentsSelectionView';
    import PaymentSummary from '../Components/PaymentSummary/PaymentSummary'
    import Repayment from '../Components/Repayment/Repayment';
    import PaymentsBanner from '../Components/PaymentBanner/PaymentBanner'
    import TeclabReenrollmentBanners from '../Components/PaymentBanner/TeclabReenrollmentBanners'
    import DocumentationUpload from '../Components/PaymentBanner/DocumentationUpload'
    import TemporaryRightDrawer from '@/components/TemporaryRightDrawer/TemporaryRightDrawer'
    import { $studentAccount, $discount, $studentCareer, $types, $suscriptions, $accounts } from '../Services';
    import { mapGetters } from 'vuex'
    import Configuration from '@/constants/configuration';
    const IBAN = require('iban');

    const PENDING_PAYMENT_STATUS = {type: null, value: 115, meaning: 'Vigente'}

    export default {
        name: 'PaymentsView',
        components: {
            CareerRadioSelector,
            PaymentsSelectionView,
            PaymentsSelectionGridView,
            PaymentsCashView,
            PaymentsSubscriptionView,
            PaymentsCompletedView,
            PaymentSummary,
            PaymentsBanner,
            TeclabReenrollmentBanners,
            DocumentationUpload,
            TemporaryRightDrawer,
            PaymentsDebitView,
            Repayment,
            Breadcrumbs,
        },
        data() {
            return {
                acceptTerms: false,
                validIban: [
                  v => IBAN.isValid(v) || this.$t('modules.portalalumno.payments.paymentsStudents.inputErrors.invalidIban')
                ],
                systemConfig: null,
                repayment: { selected: false, available: false, installments: 3 },
                showExtraBenefit: false,
                generatePaymentIds: false,
                selectedMethod: { id: null },
                step: 1,
                successMessage: null,
                prepaids: [],
                productWithPricePrepaids: [],
                summaryButtons: {
                    primary: {
                        text: this.$t('modules.portalalumno.payments.paymentsStudents.view.labels.continue'),
                        disabled: true,
                        visible: true,
                        callback: () => { this.openPaymentModal() },
                        loading: false,
                        success: false,
                        error: false,
                    },
                    secondary: {
                        text: this.$t('modules.portalalumno.payments.paymentsStudents.view.labels.back'),
                        disabled: false,
                        visible: false,
                        callback: () => { this.previousStep() }
                    },
                    tertiary: {
                        text: this.$t('modules.portalalumno.payments.paymentsStudents.view.labels.repayment'),
                        disabled: false,
                        visible: false,
                        callback: () => { this.goToRepayment() }
                    },
                    directDebit: {
                        text: 'Domiciliar pago',
                        disabled: true,
                        visible: true,
                        callback: () => { this.onDirectDebitClick() },
                        loading: false,
                        success: false,
                        error: false,
                    },
                },
                resumen: {
                    items: {
                        subtotal: { title: 'Subtotal', items: [], monto: 0 },
                        scholarships: { title: 'Becas', items: [], monto: 0 },
                        benefits: { title: 'Beneficios', items: [], monto: 0 },
                        discounts: { title: 'Descuentos', items: [], monto: 0 },
                        repayments: { title: 'Subtotal', items: [], monto: 0 },
                        adminExpenses: { title: 'Gastos Administrativos', items: [], monto: 0 },
                    },
                    cards: [
                        { paymentId: null, amount: null },
                        { paymentId: null, amount: null },
                    ],
                    total: 0,
                    tea: '0,00%',
                    cft: '0,00%',
                    paymentIntent: 0
                },
                allItemsResumen: {
                  items: {
                    subtotal: { title: 'Subtotal', items: [], monto: 0 },
                    scholarships: { title: 'Becas', items: [], monto: 0 },
                    benefits: { title: 'Beneficios', items: [], monto: 0 },
                    discounts: { title: 'Descuentos', items: [], monto: 0 },
                    repayments: { title: 'Subtotal', items: [], monto: 0 },
                    adminExpenses: { title: 'Gastos Administrativos', items: [], monto: 0 },
                  },
                  cards: [
                    { paymentId: null, amount: null },
                    { paymentId: null, amount: null },
                  ],
                  total: 0,
                  tea: '0,00%',
                  cft: '0,00%',
                  paymentIntent: 0
                },
                coupon: {
                    payment: null,
                    number: null,
                    manualOpNumber: null,
                    creationDate: null,
                    barcode: {
                        type: null,
                        codeNumber: null
                    },
                    externalResourceUrl: null,
                    dateOfExpiration: null
                  
                },
                payments: [],
                hiddenPayments: [],
                paymentsNext: [],
                subscriptionPaymentTypes: [],
                filteredSubscriptionsTypes: [],
                subscriptions: [],
                reenrollmentItems: [],
                allReenrollmentItems: [],
                filteredSubscriptions: [],
                subscriptionMethod: {
                  id: 'SUS',
                  type: 'suscripcion',
                  name: 'Suscripción',
                  icon: 'mdi-account-cash-outline',
                  off: 0,
                },
                productsToHide: [],
                documentationDrawerOpen: false,
                hasDebt: false,
                teclabReenrollment: null,
                ippReenrollment: null,
                adaptationInsuranceTerms: [],
                referedCredits: 0,
                creditCards: [],
                iv: 0,
                aux:'',
                showModal: false,
                showAgreementModal: false,
                banco: '',
                iban: '',
                modalErrors: [],
                loadingDirectDebit: false,
                selectedRegister: '',
                thankYouOpened: false
            };
        },
        computed: {
            ...mapGetters({
                studentRegister: 'commons/getStudentActualRegister',
                studentId: 'commons/getStudentId',
                studentUserId: 'commons/getStudentUserID',
                studentData: 'commons/getStudentData',
                studentRegisters: 'commons/getStudentRegisters',
            }),
            unselectedReenrollmentsAccountIds() {
              const selectedReenrollmentsIds = this.resumen.items.subtotal.items.filter(item => item.reenrollmentId).map(item => item.reenrollmentId)
              const selectedAccountIds = this.resumen.items.subtotal.items.filter(item => item.id).map(item => item.id)
              if(selectedAccountIds) {
                const unselectedAccountIds = this.allItemsResumen.items.subtotal.items.filter(item => !selectedAccountIds.includes(item.id)).map(item => item.id)
                return unselectedAccountIds
              }
              const unselectedReenrollmentsAccountIds = this.allItemsResumen.items.subtotal.items.filter(item => !selectedReenrollmentsIds.includes(item.reenrollmentId)).map(item => item.id)
              return unselectedReenrollmentsAccountIds
            },
            enableRepayment() {
                return this.repayment.available && this.payments.filter(payment => payment.selected && payment.status == 117 && payment.groupId === 1).length >= this.repayment.installments
            },
            showBanner(){
                if(this.payments[this.payments.length - 1]?.options?.benefitExtra > 0 && this.paymentsNext.length > 0 && (this.payments.length + this.paymentsNext.length) > 4){
                  return true
                }else{
                  return false
                }
            },
            extraBenefitPercentage(){
              if(this.ippReenrollment?.accounts[this.ippReenrollment.accounts.length - 1]?.benefitExtra){
                return this.ippReenrollment?.accounts[this.ippReenrollment.accounts.length - 1]?.benefitExtra
              }else{
                return this.payments[this.payments.length - 1]?.options?.benefitExtra
              }
            },
            filteredPaymentsNextByCountryConstants() {
              const ENROLLMENT_PRODUCT_ID = this.$sisConstants('modules.products.matricula')
              if (!this.$countryConstants.student_pays_enrollment) {
                return this.paymentsNext.filter((p) => p.billingProduct !== ENROLLMENT_PRODUCT_ID)
              }

              return this.paymentsNext
            },
            filteredPaymentsByCountryConstants() {
              const ENROLLMENT_PRODUCT_ID = this.$sisConstants('modules.products.matricula')
              if (!this.$countryConstants.student_pays_enrollment) {
                return this.payments.filter((p) => p.billingProduct !== ENROLLMENT_PRODUCT_ID)
              }

              return this.payments
            }
        },
        async mounted() {
            if (this.$isGestor) {
              this.getSubscriptionPaymentTypes()
              this.getSubscriptions()
            }
            this.systemConfig = (await this.$getSystemConfig())?.data
            if(!this.studentRegisters){
              const student = JSON.parse(localStorage.getItem('alumnoSeleccionado'));
              await this.$store.dispatch('commons/setStudentData', student.userData.identification);
            }
            this.selectedRegister = this.studentRegisters[0].legajo
            this.specialPayFlow()
        },
        methods: {
            closeDocumentationUpload(processingId) {
                if (processingId) this.getProductsWithPrice()
                this.documentationDrawerOpen = false
            },
            async getProductsWithPrice() {
                if(!this.systemConfig?.dues || this.$country ==='mexico'){
                  try {
                      const {data} = await $studentCareer.getStudentDebt(this.studentRegister)
                      if (data?.product !== 80 && data?.prepaids && data.prepaids.length > 0) {
                         this.productWithPricePrepaids = data.prepaids
                         this.productWithPricePrepaids.sort((a, b) => (a.dayFrom > b.dayFrom) ? 1 : -1)
                       }
                      data.benefit?.products.map(item => {item.amount = item.amount? parseInt(this.$decryter(item.amount)):null;
                                                item.percentage = item.percentage? parseInt(this.$decryter(item.percentage)):null});
                      data.products?.map(item =>{item.amount = parseInt(this.$decryter(item.amount))}); 
                      data.discount?.details.map(item => {item.bianualAmount= item.bianualAmount? parseInt(this.$decryter(item.bianualAmount)):null
                                                item.bianualPercentage= item.bianualPercentage? parseInt(this.$decryter(item.bianualPercentage)):null
                                                item.bimesterAmount= item.bimesterAmount? parseInt(this.$decryter(item.bimesterAmount)):null 
                                                item.bimesterPercentage= item.bimesterPercentage? parseInt(this.$decryter(item.bimesterPercentage)):null})
                      data.referedCredits = data.referedCredits? parseInt(this.$decryter(data.referedCredits)):null;
                      data.scholarship?.products.map(item => {item.amount = item.amount? parseInt(this.$decryter(item.amount)):null
                                                    item.percentage = item.percentage? parseInt(this.$decryter(item.percentage)):null});
                      data.uniqueDiscount = data.uniqueDiscount? parseInt(this.$decryter(data.uniqueDiscount)):null;
                      this.teclabReenrollment = data
                  } catch (error) {
                      this.teclabReenrollment = null
                      throw error
                  }
                }
            },
            async getAdaptationInsurance() {
                try {
                    const {data} = await $studentAccount.find('getAdaptationInsuranceTerms', null, { params: { studentId: this.studentId }})
                    this.adaptationInsuranceTerms = data.termIdLst
                } catch (error) {
                    this.adaptationInsuranceTerms = []
                    throw error
                }
            },
            checkParam(param, array) {
                const getQueryParams = ( params, url ) => {
                    const href = url;
                    const reg = new RegExp( `[?&]${params}=([^&#]*)`,'i');
                    const queryString = reg.exec(href);
                    return queryString ? queryString[1] : null;
                };
                const payParam = getQueryParams(param,this.$route.hash);
                return array.includes(payParam) ? payParam : null
            },
            specialPayFlow() {
                if (this.$route.params.billingProduct){
                    const specialPays = this.hiddenPayments.filter(payment => payment.billingProduct == this.$route.params.billingProduct)
                    const payment = specialPays.slice(-1)
                    this.onBillingChange(payment)
                    this.onPayClick()
                }
            },
            dateFormat(dateString) {
                const date = new Date(dateString)
                return `${date.getUTCDate()}/${date.getUTCMonth() + 1}/${date.getUTCFullYear().toString().substr(-2)}`
            },
            isPendingOrProcessing(paymentStatus) {
                const statusValue = typeof paymentStatus === 'object' ? paymentStatus?.value : paymentStatus
                const statusMeaning = typeof paymentStatus === 'object' ? paymentStatus?.meaning : paymentStatus
                if ([123, 200].includes(statusValue)) return true
                if (['Pendiente', 'Procesando'].includes(statusMeaning)) return true
            },
            async fetchData() {
                try {
                    this.productsToHide = [`${this.$sisConstants('modules.products.matricula')}`]

                    this.getConfig()
                    const response = await $studentAccount.findById(this.studentId)
                    const debtResponse = await $studentCareer.getStudentDebt(this.selectedRegister ? this.selectedRegister : this.studentRegister)
                    const accountStatusById = (response?.data?.accounts || []).reduce((acc, item) => {
                        if (item?.id) acc[item.id] = item.paymentStatus || null
                        return acc
                    }, {})
                    this.hasDebt = !!debtResponse.data.products;
                    const payments = []
                    this.ippReenrollment = response.data
                    this.repayment.available = this.$isTeclab ? false : response.data.repaymentAvailable
                    this.repayment.installments = response.data.minInstallmentsRepayment

                    debtResponse.data.products.forEach((product) => {
                      product.accountDescription = product.isBilledIndividually ? this.$t('modules.portalalumno.payments.paymentsStudents.view.labels.tuition') : `Cuota ${product.installment} de ${product.installments}`
                      payments.push(product);
                    });
                    
                    if(!this.$isTeclab) { 

                        this.referedCredits =  response.data.benefit ? parseInt(this.$decryter(response.data.benefit?.referredAmount)) : 0
                        response.data.uniqueDiscount = response.data.uniqueDiscount? parseInt(this.$decryter(response.data.uniqueDiscount)):null
                        response.data.prepaids?.map(item => {item.percentage = parseInt(this.$decryter(item.percentage))})
                        response.data.benefit?  response.data.benefit.referredAmount = parseInt(this.$decryter(response.data.benefit?.referredAmount)): null
                        response.data.scholarship?.amount && (response.data.scholarship.amount = parseInt(this.$decryter(response.data.scholarship.amount)))
                        response.data.scholarship?.percentage && (response.data.scholarship.percentage = parseInt(this.$decryter(response.data.scholarship.percentage)))
                    
                    }
                    if (this.$isTeclab) {
                        debtResponse.data.products.map(item =>{item.amount = parseFloat(this.$decryter(item.amount))})
                        response.data.uniqueDiscount = response.data.uniqueDiscount? parseFloat(this.$decryter(response.data.uniqueDiscount)):null
                        response.data.prepaids?.map(item => {item.percentage = parseInt(this.$decryter(item.percentage))})
                        this.productsToHide = []
                        await this.getProductsWithPrice()
                        if(this.systemConfig?.adaptationInsurance) {
                          await this.getAdaptationInsurance()
                        }
                        if (this.teclabReenrollment && this.teclabReenrollment.products) {
                            this.teclabReenrollment.products.forEach((prod, prodIndex) => {
                              let total = prod.amount
                              let off = 0
                              let extraOff = 0
                              let benefitAmount = 0
                              let scholarshipAmount = 0

                              const discount = this.teclabReenrollment.discount?.details?.find(disc => disc.billingProduct.id == prod.idProduct)
                              if (discount) {
                                if (prod.idProduct == this.$sisConstants('modules.products.matricula')) {
                                  if (discount.bianualAmount) off += discount.bianualAmount / total * 100
                                  else if (discount.bianualPercentage) off += discount.bianualPercentage
                                } else if (prod.idProduct == this.$sisConstants('modules.products.arancel')) {
                                  let discountOff = 0
                                  if (discount.bimesterAmount) discountOff = discount.bimesterAmount / total * 100
                                  else if (discount.bimesterPercentage) discountOff = discount.bimesterPercentage
                                  off += discountOff

                                  let bianualOff = 0
                                  if (discount.bianualAmount) bianualOff = discount.bianualAmount / total * 100
                                  else if (discount.bianualPercentage) bianualOff = discount.bianualPercentage
                                  if (bianualOff && bianualOff > discountOff) extraOff = bianualOff - discountOff
                                }
                              }

                              if (this.teclabReenrollment.benefit?.statusProcessing?.status.value == 93 || !this.teclabReenrollment.benefit?.documentation.length) {
                                const benefit = this.teclabReenrollment.benefit?.products?.find(b => b.billingProduct == prod.idProduct)
                                if (benefit && (this.$isTeclab || off < 100)) {
                                  benefitAmount = benefit.percentage ? total * benefit.percentage / 100 : benefit.amount
                                  if (benefitAmount > total) {
                                    benefitAmount = total
                                  }
                                  if (this.$isIPP) {
                                    total -= benefitAmount
                                  }
                                  off += benefitAmount / prod.amount * 100
                                }
                              }

                              const isAdaptationInsurance = (prod.idProduct == this.$sisConstants('modules.products.arancel')
                                      || prod.idProduct == this.$sisConstants('modules.products.matricula'))
                                  && this.adaptationInsuranceTerms.includes(prod.idTerm)
                              if (isAdaptationInsurance) {
                                benefitAmount = prod.amount
                                off = 100
                              }

                              if (this.teclabReenrollment.referedCredits) {
                                this.referedCredits = this.teclabReenrollment.referedCredits
                                if (this.$isIPP) {
                                  total -= this.referedCredits
                                }
                              }

                              if (!this.teclabReenrollment.scholarship?.renew || this.teclabReenrollment.scholarship?.renew.status?.value == 77) {
                                const scholarship = this.teclabReenrollment.scholarship?.products?.find(s => s.billingProduct == prod.idProduct)
                                if (scholarship && (this.$isTeclab || off < 100)) {
                                  scholarshipAmount = scholarship.percentage ? total * scholarship.percentage / 100 : scholarship.amount
                                  if (scholarshipAmount > total) {
                                    scholarshipAmount = total
                                  }
                                  if (this.$isIPP) {
                                    total -= scholarshipAmount
                                  }
                                  off += scholarship.percentage || scholarship.amount / total * 100
                                }
                              }
                              if (this.$isIPP && off > 100) off = 100

                              const dateId = (new Date()).getTime()
                              if(this.$country ==='peru' || this.$country ==='mexico' ) {
                                payments.push({
                                  accountDescription: prod.name,
                                  billingProduct: { id: prod.idProduct },
                                  paymentAmount: prod.amount,
                                  scholarshipAmount,
                                  benefitAmount,
                                  benefitExtra: null,
                                  id: null,
                                  reenrollmentId: `${dateId}-${prodIndex}`,
                                  term: { id: prod.idTerm, description: prod.termCode},
                                  paymentDueDate: prod.dueDate,
                                  paymentInstallment: prod.installment,
                                  paymentInstallments: prod.installments,
                                  mandatory: prod.mandatory,
                                  paymentStatus: PENDING_PAYMENT_STATUS,
                                  paymentStudentRecord: this.studentRegister,
                                  off,
                                  reenrollmentExtraOff: extraOff,
                                  adaptationInsurance: isAdaptationInsurance,
                                })
                              }
                              else {
                                payments.push({
                                  accountDescription: prod.name,
                                  billingProduct: { id: prod.idProduct },
                                  paymentAmount: prod.amount,
                                  scholarshipAmount,
                                  benefitAmount,
                                  benefitExtra: null,
                                  id: null,
                                  reenrollmentId: `${dateId}-${prodIndex}`,
                                  term: { id: prod.idTerm, description: prod.termCode},
                                  paymentDueDate: prod.dueDate,
                                  paymentInstallment: 1,
                                  paymentInstallments: 1,
                                  mandatory: prod.mandatory,
                                  paymentStatus: PENDING_PAYMENT_STATUS,
                                  paymentStudentRecord: this.studentRegister,
                                  off,
                                  reenrollmentExtraOff: extraOff,
                                  adaptationInsurance: isAdaptationInsurance,
                                })
                              }
                            });
                        }

                    }

                    payments.sort((a, b) => {
                        const dateA = new Date(a.dueDate)
                        const dateB = new Date(b.dueDate)
                        if (dateA > dateB) return 1
                        if (dateA < dateB) return -1
                        return 0
                    });

                    const adaptationInsuranceIndex = payments.findIndex(payment => payment.adaptationInsurance)
                    if (adaptationInsuranceIndex !== -1) {
                        payments.map((payment, index) => {
                            payment.disabled = true
                            if (adaptationInsuranceIndex === 0) {
                              if (payment.adaptationInsurance && (index === 0 || payments[index - 1].adaptationInsurance)) {
                                  payment.disabled = false
                              }
                            }
                            if (index < adaptationInsuranceIndex) {
                                payment.disabled = false
                            }
                            return payment
                        })
                    }

                    const now = new Date()
                    const nextMonth = new Date(now.getFullYear(), now.getMonth() + 1, 1)
                    const groupsId = {
                        arancel: 1,
                        repactacion: 2,
                        independent: 3,
                        rematricula: 4,
                    }

                    payments.forEach(account => {

                        const exp = new Date(account.dueDate)
                        let arr = null
                        const groupId = groupsId.arancel
                        const paymentStatus = account?.paymentStatus || accountStatusById[account?.id] || null
                        const isProcessingPayment = this.isPendingOrProcessing(paymentStatus)

                        const off = 0
                        const discounts = []
                        arr = {
                            id: account.id,
                            directDebit: account.directDebit,
                            reenrollmentId: account.reenrollmentId || null,
                            title: account.name ? account.name : account.accountDescription,
                            groupId,
                            independent: groupId == groupsId.independent,
                            selected: false,
                            mandatory: account.mandatory,
                            repaymentAvailable: false,
                            studentRecord: this.studentRegister,
                            paymentStatus,
                            // this is required for re-enrollment payment
                            isHiddenProduct: account.billingProduct && this.productsToHide.includes(`${account.billingProduct.id}`),
                            billingProduct: account.billingProduct ? account.billingProduct.id : null,
                            options: {
                                term: {
                                  id: account.idTerm,
                                  code: account.termCode,
                                  description: account.termDescription,
                                },
                                dueDate: account.dueDate,
                                expiration: `Hasta el ${this.dateFormat(account.dueDate)}`,
                                paymentInstallment: account.installment,
                                paymentInstallments: account.installments,
                                isBilledIndividually: account.isBilledIndividually,
                                month: exp.getUTCMonth() + 1,
                                scholarshipAmount: account?.scholarshipAmount || 0,
                                benefitAmount: account?.benefitAmount || 0,
                                benefitExtra: this.teclabReenrollment?.products?.benefitExtra || account?.benefitExtra, 
                                extraOff: 0,
                                reenrollmentExtraOff: account.reenrollmentExtraOff ? account.reenrollmentExtraOff : 0,
                                addedExtraOff: 0,
                                off: this.$options.filters.$roundNumber(account.off ? account.off : off),
                                discounts,
                                amount: account.amount,
                                adaptationInsurance: account.adaptationInsurance,
                                disabled: !!account?.disabled || isProcessingPayment,
                                processingPayment: isProcessingPayment,
                            }
                        }
                        if (arr) {
                            if(arr.isHiddenProduct){
                                if(account.discount && account.discountAmount){
                                    arr.options.off = account.discountAmount * 100 / account.paymentAmount;
                                }
                                this.hiddenPayments.push(arr)
                            } else if (exp < nextMonth) {
                                this.payments.push(arr)
                            } else {
                                if (arr.billingProduct == this.$sisConstants('modules.products.derecho_examen')) {
                                  this.payments.push(arr)
                                } else {
                                  this.paymentsNext.push(arr)
                                  if(!this.systemConfig?.dues){
                                    this.paymentsNext.sort((a,b) => a.options.paymentInstallment - b.options.paymentInstallment).sort((a,b) => a.billingProduct - b.billingProduct)
                                  }
                                }
                            }
                        }
                    });
                    const allPayments = [...this.payments, ...this.paymentsNext]
                    this.onBillingChange(allPayments, 'all')
                    this.$nextTick(() => this.$refs.paymentSelectionGridView.selectAll(false))
                    if (!response.data.prepaids) response.data.prepaids = []

                    this.prepaids = response.data.prepaids
                    this.prepaids.sort((a, b) => (a.dayFrom > b.dayFrom) ? 1 : -1)
                } catch (error) {
                    this.prepaids = []
                    this.payments = []
                    this.paymentsNext = []
                    throw error
                }
            },
            async getSubscriptionPaymentTypes() {
              try {
                const {data} = await $types.find(null, null, { params: { type: 'SUSCRIPTION_PAYMENT_TYPE' } })
                this.subscriptionPaymentTypes = data
              } catch (err) {
                this.subscriptionPaymentTypes = []
                throw err
              }
            },
            async getSubscriptions() {
              try {
                const {data} = await $suscriptions.find(null, null, { params: { active: true } })
                this.subscriptions = data
              } catch (err) {
                this.subscriptions = []
              }
            },
            async getConfig() {
                try {
                    const response = await $accounts.find()
                    await this.$store.dispatch('commons/setMpConfig', response.data);
                } catch {
                    await this.$store.dispatch('commons/setMpConfig', null);
                }
            },
            goBackPayment() {
                if (!this.resumen.total) this.step--
                this.creditCards = []
                this.selectedMethod = {id: null};
                this.$nextTick(function () {
                  if (this.$isGestor && this.$isTeclab) {
                    this.resumen.items.adminExpenses.monto = 0
                    this.resumen.total = this.resumen.items.subtotal.monto - this.resumen.items.discounts.monto -this.resumen.items.scholarships.monto - this.resumen.items.benefits.monto
                    if (this.resumen.total < 0) this.resumen.total = 0
                  }
                })
                this.$trackEvent('Pagos', 'Volver', 'Método de pago 2')
            },
            goToRepayment() {
                this.repayment.selected = true
                this.summaryButtons.primary.disabled = true
                this.summaryButtons.secondary.visible = true
                this.summaryButtons.tertiary.visible = false

                this.resumen.items.subtotal.items = JSON.parse(JSON.stringify(this.resumen.items.repayments.items))
                this.resumen.items.subtotal.items = this.resumen.items.subtotal.items.map(item => {
                    item.title = `Arancel cuota ${item.title}`
                    return item
                })
                this.resumen.items.subtotal.monto = this.resumen.items.repayments.monto
                this.resumen.items.discounts.items = []
                this.resumen.items.discounts.monto = 0
                this.resumen.total = this.resumen.items.subtotal.monto

                this.$nextTick()
                this.definePrimaryCallback()
            },
            paymentSelected(payment) {
                if (payment.id != 'TC2' && payment.id != 'SUS') this.summaryButtons.primary.text = this.$t('modules.portalalumno.payments.paymentsStudents.view.labels.paymentLink')
                else this.summaryButtons.primary.text = this.$t('modules.portalalumno.payments.paymentsStudents.view.labels.continue')
                this.selectedMethod = payment
            },
            openPaymentModal(){
              this.showAgreementModal = true;
            },
            async onPayClick () {
                this.closeAgreementModal();
                const directDebits = []
                this.resumen.items.subtotal.items.forEach(element => {
                  if (element.directDebit) {
                    directDebits.push(element)
                  }
                });
                if (directDebits.length > 0) {
                      await this.$store.dispatch('commons/openPopUp', {
                        title: 'Recorda que hay registrada una domiciliación bancaria',
                        actionPrimary: { text: 'Aceptar', callback() {} },
                        icon: { color: 'info', name: 'mdi-bell' },
                        color: 'primary',
                        });
                }
                if(this.systemConfig?.dues) {
                  const reenrollmentStatus = await this.createReenrollmentItems('allReenrollmentItems', 'allItemsResumen')
                  if (!reenrollmentStatus) return false
                  await this.saveDiscounts('allItemsResumen');
                } else {
                  const reenrollmentStatus = await this.createReenrollmentItems('reenrollmentItems', 'resumen')
                  if (!reenrollmentStatus) return false
                  await this.saveDiscounts('resumen');
                }
                this.summaryButtons.directDebit.visible = false;
                this.step++
                if (!this.resumen.total) {
                  this.selectedMethod.id = 'FT'
                  this.coupon.payment = {id: 'Efectivo'}
                  this.summaryButtons.primary.text = this.$t('modules.portalalumno.payments.paymentsStudents.view.labels.continue')
                }
                this.summaryButtons.primary.disabled = true
                this.summaryButtons.secondary.visible = true
                this.summaryButtons.tertiary.visible = false
                this.$nextTick()
                this.$trackEvent('Pagos', 'Click - Pago 1', 'Selección de aranceles')
            },            
            onDirectDebitClick() {
              this.showModal = true;
            },
            closeModal() {
              this.showModal = false;
              this.banco = '';
              this.iban = '';
            },
            closeAgreementModal() {
              this.showAgreementModal = false;
              this.acceptTerms = false;
            },
            async onConfirmDirectDebit() {
              if(!IBAN.isValid(this.iban)){
                return;
              }
              if(this.iban == '') {
                this.modalErrors = ['Los campos son obligatorios'];
                return;
              }
              this.loadingDirectDebit = true;
              const ids = this.paymentsNext.map(item => item.id);
              ids.push(...this.payments.map(item => item.id));
              const response = await $studentAccount.postDirectDebit({studentAccountIds: ids, iban: this.iban, bank: this.banco});
              this.loadingDirectDebit = false;
              if (response) {
                this.$store.dispatch('commons/openPopUp', {
                            title: 'Domiciliación bancaria',
                            content: [{ value: '¡Datos guardados con éxito!' }],
                            actionPrimary: { text: 'Ok', callback() {} },
                            icon: { color: 'success', name: 'mdi-check' },
                            color: 'primary',
                });
                this.prepaids = []
                this.payments = []
                this.paymentsNext = []
                this.resumen = {
                    items: {
                        subtotal: { title: 'Subtotal', items: [], monto: 0 },
                        scholarships: { title: 'Becas', items: [], monto: 0 },
                        benefits: { title: 'Beneficios', items: [], monto: 0 },
                        discounts: { title: 'Descuentos', items: [], monto: 0 },
                        repayments: { title: 'Subtotal', items: [], monto: 0 },
                        adminExpenses: { title: 'Gastos Administrativos', items: [], monto: 0 },
                    },
                    cards: [
                        { paymentId: null, amount: null },
                        { paymentId: null, amount: null },
                    ],
                    total: 0,
                    tea: '0,00%',
                    cft: '0,00%',
                    paymentIntent: 0
                };
                this.fetchData();
                this.closeModal();
              } else {
                this.$store.dispatch('commons/openPopUp', {
                            title: 'Domiciliación bancaria',
                            content: [{ value: 'Error al guardar los datos.' }],
                            actionPrimary: { text: 'Ok', callback() {} },
                            icon: { color: 'error', name: 'mdi-warning' },
                            color: 'primary',
                });
                this.closeModal();
              }
            },
            clearErrors(){
              this.modalErrors = [];
            },
            showSubscriptionPaymentMethod() {
                if (this.filteredSubscriptions.length) {
                    if (!this.$refs.PSV.paymentMethods?.includes(this.subscriptionMethod)) {
                        this.$refs.PSV.paymentMethods?.push(this.subscriptionMethod)
                    }
                } else {
                    this.$refs.PSV.paymentMethods = this.$refs.PSV.paymentMethods?.filter(method => method.id != 'SUS')
                }
            },
            async createReenrollmentItems(reenrollmentItems, resumen) {
                if (this[reenrollmentItems].length) {
                    try {
                        const discountItems = this[resumen].items.discounts.items.map((item, index) => {
                          return item.monto + this[resumen].items.benefits.items[index].monto + this[resumen].items.scholarships.items[index].monto
                        })
                        if (this.referedCredits || this.teclabReenrollment?.uniqueDiscount || this.ippReenrollment?.uniqueDiscount) {
                            let remainingCredits = this.referedCredits + this.teclabReenrollment?.uniqueDiscount ?? 0 + this.ippReenrollment?.uniqueDiscount ?? 0

                            this[resumen].items.subtotal.items.forEach((item, index) => {
                                if (remainingCredits) {
                                    if (item.monto - discountItems[index] >= remainingCredits) {
                                        discountItems[index] += remainingCredits
                                        remainingCredits = 0
                                    } else {
                                        discountItems[index] += item.monto - discountItems[index]
                                        remainingCredits -= item.monto - discountItems[index]
                                    }
                                }
                            })
                        }
                        const reenrollmentItemsParam = this[reenrollmentItems].map((reenrollmentItem, index) => {
                          const amount = this[resumen].items.subtotal.items.find(subtotalItem => subtotalItem.reenrollment?.billingProduct == reenrollmentItem.product)?.monto
                          reenrollmentItem.amount = amount
                          reenrollmentItem.paid = !this.systemConfig?.contract && this.systemConfig?.dues ? false : amount <= discountItems[index]
                          reenrollmentItem.user = this.studentUserId ? this.studentUserId : null
                          return reenrollmentItem
                        })

                        const params = {}
                        if (this.$isIPP) params.isNi = true
                        const accounts = await $studentAccount.create(reenrollmentItemsParam, { params })
                        accounts.data.forEach(acc => {
                            const subtotal = this.resumen.items.subtotal.items.find(s => s.reenrollmentId == acc.reenrollmentId)
                            if (subtotal) subtotal.id = acc.accountId
                            const subtotalAllItems = this.allItemsResumen.items.subtotal.items.find(s => s.reenrollmentId == acc.reenrollmentId)
                            if (subtotalAllItems) subtotalAllItems.id = acc.accountId

                            const discount = this.resumen.items.discounts.items.find(s => s.reenrollmentId == acc.reenrollmentId)
                            if (discount) discount.id = acc.accountId
                            const discountAllItems = this.allItemsResumen.items.discounts.items.find(s => s.reenrollmentId == acc.reenrollmentId)
                            if (discountAllItems) discountAllItems.id = acc.accountId
                        })
                        if (this.adaptationInsuranceTerms.length && this[resumen].items.subtotal.items.some(subtotalItem => subtotalItem.reenrollment.options.adaptationInsurance)) {
                            $studentAccount.create({ id: this.studentId }, {}, 'confirmAdaptationInsurance')
                        }
                        return true
                    } catch (error) {
                        this.$store.dispatch('commons/openPopUp', {
                            title: error.codeMeaning && error.codeMeaning != '' ? error.codeMeaning : this.$t('modules.portalalumno.payments.paymentsStudents.view.reenrollment.error_creating'),
                            content: null,
                            actionPrimary: { text: this.$t('actions.accept'), callback() {} },
                            icon: { color: 'error', name: 'mdi-close' },
                            color: 'primary',
                        });
                        return false
                    }
                } else return true
            },
            async saveDiscounts(resumen) {
                const legajo = this.studentRegister;
                const discountData = {
                    studentCareerId: legajo,
                    items: this[resumen].items.discounts.items.map((item, index) => {
                        const {subtotal, benefits, scholarships} = this[resumen].items
                        return {
                            accountId: item.id,
                            discountAmmount: item.monto,
                            benefitAmmount: benefits.items[index].monto - (subtotal.items[index].monto - item.monto) <= 0 ? benefits.items[index].monto : subtotal.items[index].monto - item.monto,
                            scholarshipAmount: scholarships.items[index].monto - (subtotal.items[index].monto - item.monto - benefits.items[index].monto) <= 0 ? scholarships.items[index].monto : subtotal.items[index].monto - item.monto - benefits.items[index].monto
                        }
                    }),
                    
                    paid: !this.resumen.total
                };
                
                if (this.referedCredits ||  this.teclabReenrollment?.uniqueDiscount || this.ippReenrollment?.uniqueDiscount ) {
                  let remainingCredits = (this.referedCredits ?? 0)  + (this.teclabReenrollment?.uniqueDiscount ?? this.ippReenrollment?.uniqueDiscount ?? 0)
                  this[resumen].items.subtotal.items.forEach((item, index) => {
                    const {benefitAmmount, discountAmmount, scholarshipAmount} = discountData.items[index]
                    
                    if (remainingCredits) {
                      if (item.monto - discountAmmount - benefitAmmount - scholarshipAmount >= remainingCredits) {
                        discountData.items[index].benefitAmmount += remainingCredits
                        remainingCredits = 0
                      } else {
                        discountData.items[index].benefitAmmount += item.monto - discountAmmount - benefitAmmount - scholarshipAmount
                        remainingCredits -= item.monto - discountAmmount - benefitAmmount - scholarshipAmount
                      }
                    }
                  })
                }
                const {data} = await $discount.create(discountData);
                this.resumen.paymentIntent = data.intent;
                this.allItemsResumen.paymentIntent = data.intent;
            },
            previousStep() {
                this.creditCards = []
                if (this.step > 1) {
                    this.step = 1
                    this.summaryButtons.directDebit.visible = true
                    this.selectedMethod = {id: null}
                    if (this.$isGestor && this.$isTeclab) {
                      this.resumen.items.adminExpenses.monto = 0
                    }
                    this.$trackEvent('Pagos', 'Cancelar', 'Step pago')
                } else {
                    this.repayment.selected = false
                    this.summaryButtons.tertiary.visible = true
                }

                if (!this.repayment.selected) {
                    const payments = [...this.payments.filter(payment => payment.selected), ...this.paymentsNext.filter(payment => payment.selected)]
                    this.onBillingChange(payments)
                }

                this.resetButtons()
            },
            definePrimaryCallback() {
                if (this.step == 1) {
                    if (!this.repayment.selected) this.summaryButtons.primary.callback = () => { this.openPaymentModal() }
                    else this.summaryButtons.primary.callback = () => { this.$refs.REP.confirm() }
                } else if (this.step == 2 && this.selectedMethod.id == 'TC1') {
                    this.summaryButtons.primary.callback = () => { this.analyticsPaymentEvent(); this.$refs.TC1.saveBillingData() }
                } else if (this.step == 2 && this.selectedMethod.id == 'TC2') {
                    this.summaryButtons.primary.callback = () => { this.analyticsPaymentEvent(); this.$refs.TC2.paymentCardsInfo() }
                } else if (this.step == 2 && this.selectedMethod.id == 'TD') {
                    this.summaryButtons.primary.callback = () => { this.analyticsPaymentEvent(); this.$refs.TD.$refs.debitCard.saveBillingData() }
                } else if (this.step == 2 && this.selectedMethod.id == 'FT') {
                    this.summaryButtons.primary.callback = () => { this.analyticsPaymentEvent(); this.resumen.total ? this.$refs.FT.generateCoupon() : this.$refs.FT.oneCentReceipt() }
                } else if (this.step == 2 && this.selectedMethod.id == 'SUS') {
                    this.summaryButtons.primary.callback = () => { this.analyticsPaymentEvent(); this.$refs.SUS.paymentInstallmentsSelected() }
                }
            },
            analyticsPaymentEvent() {
                const pay = this.payments.find(payment => payment.selected &&
                    (payment.billingProduct == this.$sisConstants('modules.products.matricula') ||
                    payment.billingProduct == this.$sisConstants('modules.products.examen') ||
                    payment.billingProduct == this.$sisConstants('modules.products.nueva_tne') ||
                    payment.billingProduct == this.$sisConstants('modules.products.revalidacion_tne')))
                this.$trackEvent('Pagos', `Pago ${pay ? pay.title : 'Arancel'}`, 'Método de pago 2')
            },
            resetButtons() {
                if (this.step == 1) {
                    this.summaryButtons.primary.disabled = !this.payments.length
                    this.summaryButtons.primary.text = this.$t('modules.portalalumno.payments.paymentsStudents.view.labels.continue')
                    this.summaryButtons.primary.loading = false
                    this.summaryButtons.primary.success = false
                    this.summaryButtons.primary.error = false
                    if (this.repayment.selected) {
                        this.summaryButtons.secondary.visible = true
                        this.summaryButtons.tertiary.visible = false
                    } else {
                        this.summaryButtons.secondary.visible = false
                        this.summaryButtons.tertiary.visible = this.enableRepayment
                    }
                    this.$nextTick()
                    this.definePrimaryCallback()
                }
            },
            onBillingChange(payments, itemsToUpdate='selected') {
                const resumen = itemsToUpdate === 'all' ? 'allItemsResumen' : 'resumen';
                const reenrollmentItems = itemsToUpdate === 'all' ? 'allReenrollmentItems' : 'reenrollmentItems'
                this.summaryButtons.primary.disabled = !payments.length
                this.summaryButtons.directDebit.disabled = !payments.length
                this.summaryButtons.tertiary.visible = this.enableRepayment
                if (payments.some(payment => payment.options.adaptationInsurance)) {
                  this.summaryButtons.primary.text = this.$t('modules.portalalumno.payments.paymentsStudents.view.labels.applyAdaptationInsurance')
                } else {
                  this.summaryButtons.primary.text = this.$t('modules.portalalumno.payments.paymentsStudents.view.labels.continue')
                }

                this[reenrollmentItems] = []
                this[resumen].items.subtotal.items = payments.map(payment => {
                    if (payment.reenrollmentId) {
                      if(this.systemConfig.dues && !this.systemConfig.contract) {
                        this[reenrollmentItems].push({
                          reenrollmentId: payment.reenrollmentId,
                          product: payment.billingProduct,
                          term: payment.options.term.id,
                          student: this.studentId,
                          studentCareer: this.studentRegister,
                          dueDate: payment.options.dueDate,
                          amount: payment.options.amount,
                          installment: payment.options.paymentInstallment,
                          installments: payment.options.paymentInstallments
                        })
                      } else {
                        this[reenrollmentItems].push({
                          reenrollmentId: payment.reenrollmentId,
                          product: payment.billingProduct,
                          term: payment.options.term.id,
                          student: this.studentId,
                          studentCareer: this.studentRegister,
                          dueDate: payment.options.dueDate,
                          amount: payment.options.amount,
                        })
                      }
                    }

                    return {

       id: payment.id,
                        reenrollment: payment.id == null ? payment : null,
                        reenrollmentId: payment.reenrollmentId,
                        monto: payment.options.amount,
                        title: payment.title,
                        directDebit: payment.directDebit
                    }
                })
                this[resumen].items.discounts.items = payments.map(payment => {
                    const scholarshipBenefitOff = payment.options.amount ? (payment.options.scholarshipAmount + payment.options.benefitAmount) / payment.options.amount * 100 : 0
                    const discountOff = payment.options.off - scholarshipBenefitOff
                    let off = payment.options.addedExtraOff ? discountOff + payment.options.addedExtraOff : discountOff
                    let amount = payment.options.amount * off / 100
                    

                    if(this.teclabReenrollment?.accumulativeDiscount){
                      if (payment.options.extraOff > 0) {
                        amount = amount + (payment.options.amount - amount) * payment.options.extraOff / 100
                        off = off + (100 - off) * payment.options.extraOff / 100   
                        if (off > 100) off = 100
                    }
                    }else{
                      if (payment.options.extraOff > 0) {
                        if(payment.billingProduct == 80){
                          amount = amount + ((payment.options.amount - amount) * payment.options.extraOff / 100)
                          off = off + payment.options.extraOff
                          if (off > 100) off = 100
                        }else{
                          amount = amount + (payment.options.amount * payment.options.extraOff / 100)
                          off = off + payment.options.extraOff
                          if (off > 100) off = 100
                        }
                      }
                    }
                    

                    if (payment.reenrollmentId) {
                        const reenrollment = this[reenrollmentItems].find(item => item.reenrollmentId == payment.reenrollmentId)
                        reenrollment.amount -= amount
                    }

                    return {
                        id: payment.id,
                        reenrollment: payment.id == null ? payment : null,
                        reenrollmentId: payment.reenrollmentId,
                        monto: payment.options.amount ? amount : 0,
                        title: `${payment.title} - ${payment.options.amount ? this.$options.filters.$roundNumber(off) : 0}% off`
                    }
                })

                this[resumen].items.benefits.items = payments.map(payment => {
                  if (payment.options.adaptationInsurance) {
                    return {
                      id: payment.id,
                      monto: payment.options.amount,
                      title: `${payment.title} - 100% off`
                    }
                  } else {
                    let benefitAmount = 0
                    let benefitOff = 0

                    if (payment.options.amount) {
                        const scholarshipOff = payment.options.scholarshipAmount / payment.options.amount * 100
                        benefitOff = payment.options.benefitAmount / payment.options.amount * 100
                        const discountOff = payment.options.off - scholarshipOff - benefitOff
                        const off = payment.options.addedExtraOff ? discountOff + payment.options.addedExtraOff : discountOff
                        benefitAmount = benefitOff + off < 100 ? payment.options.benefitAmount : payment.options.amount * (100 - off) / 100
                    }
                    
                    return {
                      id: payment.id,
                      monto: benefitAmount,
                      title: `${payment.title} - ${this.$options.filters.$roundNumber(benefitOff)}% off`
                    }
                  }
                })

                if (this.referedCredits && payments.length) {
                  this[resumen].items.benefits.items.push({
                    id: 'referedFriend',
                    monto: this.$options.filters.$roundNumber(this.referedCredits),
                    title: this.$t('modules.portalalumno.payments.paymentsStudents.view.benefit.type.referedFriend')
                  })
                }
                else if (this.teclabReenrollment?.uniqueDiscount && payments.length) {
                  this[resumen].items.benefits.items.push({
                    id: 'uniqueDiscount',
                    monto: this.$options.filters.$roundNumber(this.teclabReenrollment.uniqueDiscount),
                    title: this.$t('modules.portalalumno.payments.paymentsStudents.view.benefit.type.uniqueDiscount')
                  })
                }
                else if (this.ippReenrollment.uniqueDiscount && payments.length) {
                  this[resumen].items.benefits.items.push({
                    id: 'uniqueDiscount',
                    monto: this.$options.filters.$roundNumber(this.ippReenrollment.uniqueDiscount),
                    title: this.$t('modules.portalalumno.payments.paymentsStudents.view.benefit.type.uniqueDiscount')
                  })
                }
                this[resumen].items.scholarships.items = payments.map(payment => {
                  const scholarshipOff = payment.options.scholarshipAmount / payment.options.amount * 100
                  const benefitOff = payment.options.benefitAmount / payment.options.amount * 100
                  const discountOff = payment.options.off - scholarshipOff - benefitOff
                  const off = payment.options.addedExtraOff ? discountOff + payment.options.addedExtraOff : discountOff
                  const scholarshipAmount = scholarshipOff + benefitOff + off < 100
                    ? payment.options.scholarshipAmount
                    : benefitOff + off < 100
                      ? payment.options.amount * (100 - (off + benefitOff)) / 100
                      : 0
                  return {
                    id: payment.id,
                    monto: scholarshipAmount,
                    title: `${payment.title} - ${this.$options.filters.$roundNumber(scholarshipOff)}% off`
                  }
                })

                this[resumen].items.repayments.items = payments.filter(payment => payment.repaymentAvailable && payment.selected).map(payment => ({
                    id: payment.id,
                    monto: payment.options.amount,
                    title: `${payment.options.paymentInstallment}/${payment.options.paymentInstallments}`
                }))
                this[resumen].items.repayments.monto = this[resumen].items.repayments.items.reduce((acc, curr) => {return acc += +curr.monto}, 0)
                this[resumen].items.subtotal.monto = payments.reduce((acc, curr) => {return acc += +curr.options.amount}, 0)
                this[resumen].items.discounts.monto = this[resumen].items.discounts.items.reduce((acc, curr) => {return acc += +curr.monto}, 0)
                this[resumen].items.benefits.monto = this[resumen].items.benefits.items.reduce((acc, curr) => {return acc += +curr.monto}, 0)
                this[resumen].items.scholarships.monto =this[resumen].items.scholarships.items.reduce((acc, curr) => {return acc += +curr.monto}, 0)
                this[resumen].total = this[resumen].items.subtotal.monto - this[resumen].items.discounts.monto - this[resumen].items.scholarships.monto - this[resumen].items.benefits.monto
                if (this[resumen].total < 0) this[resumen].total = 0

                if (this.$isGestor && this.$isTeclab) {
                    const paymentsSelectedBillingProductIds = payments.filter(payment => payment.selected).map(payment => payment.billingProduct)
                    const paymentsNextWithoutSelectedBillingProductIds = this.paymentsNext.filter(payment => payment.selected).reduce((acc, payment) => {
                      if (![this.$sisConstants('modules.products.matricula'), this.$sisConstants('modules.products.arancel')].includes(payment.billingProduct)) {
                        acc.push(payment.billingProduct)
                      }
                      return acc
                    }, [])
                    const paymentBillingProductIds = [...new Set([...paymentsSelectedBillingProductIds, ...paymentsNextWithoutSelectedBillingProductIds])]
                    this.filteredSubscriptions = this.subscriptions.filter(subscription => {

                        const subscriptionPaymentBillingProductIds = subscription.suscriptionDetail.map(detail => detail.billingProduct.id)

                        if (paymentBillingProductIds.length !== subscriptionPaymentBillingProductIds.length) return false
                        const uniqueValues = new Set([...paymentBillingProductIds, ...subscriptionPaymentBillingProductIds])
                          for (const v of uniqueValues) {
                              const aCount = paymentBillingProductIds.filter(e => e == v).length
                              const bCount = subscriptionPaymentBillingProductIds.filter(e => e == v).length
                              if (aCount != bCount) return false
                          }
                        return true

                    })
                    this.filteredSubscriptionsTypes = this.subscriptionPaymentTypes.filter(type => {
                        let subscriptionTypeApply = false
                        this.filteredSubscriptions.forEach(subscription => {
                            if (type.value == subscription.suscriptionPaymentType.value) {
                                subscriptionTypeApply = true
                            }
                        })
                        return subscriptionTypeApply
                    })
                }
                this.$nextTick()
            },
            async nextStepChange(data = null) {
                if (this.step == 2 && this.studentData && this.studentData.studentType?.value == 7 && !this.studentData.signed) {
                  // Actualizamos datos de alumno para saber si pago o no
                  await this.$store.dispatch('commons/initData');
                }                
                
                const successfulStatuses = ['approved', 'pending', 'in_process', 'debitOk'];
                if (data && successfulStatuses.includes(data)) {
                  this.$store.commit('commons/SET_SIGNED_USERDATA', true);
                }
                
                await this.checkAndOpenThankYouPage();
                this.successMessage = data || '';
                this.step = this.step + 1;

                if (!data) return;

                if (this.thankYouOpened) return;
              
                const validStatuses = ['approved', 'pending', 'in_process'];

                if (validStatuses.includes(data)) {
                  await this.checkAndOpenThankYouPage();
                  this.thankYouOpened = true; // para que no se vuelva a abrir
                }
            },
            async checkAndOpenThankYouPage() {
              try {

                const { data } = await $studentAccount.hasFirstPayment(this.studentId);
                const hasFirstPayment = data?.hasFirstPayment ?? data?.student?.hasFirstPayment;
                const thankYouStorageKey = `thankYouOpened:${this.studentId}`;
                const thankYouAlreadyOpened = localStorage.getItem(thankYouStorageKey) === 'true';

                if (hasFirstPayment === false && !thankYouAlreadyOpened) {
                  
                  let thankYouUrl;
                    
                  // Verificar si es entorno de pruebas
                  const host = window.location.hostname;
                  const isTestEnvironment = host.includes('localhost') || host.includes('127.0.0.1') || host.includes('cerem-dev.net');
                    
                  if (isTestEnvironment) {
                    // En entorno de pruebas usar Google como placeholder
                    thankYouUrl = 'https://www.google.com';
                    
                  } else {
                    thankYouUrl = Configuration.value('thankYouURL');
                  }
                    
                  window.open(thankYouUrl, '_blank');
                  localStorage.setItem(thankYouStorageKey, 'true');
                }
                
              } catch (error) {
                // eslint-disable-next-line no-console
                console.error('Error verificando el primer pago del estudiante:', error);
              }
          },
            setDue(due) {
              if (due) {
                if (Array.isArray(due)) this.creditCards = due
                else this.creditCards = [ due ]
              } else {
                this.creditCards = []
              }
            },
            updateCouponExternalInfo(payload) {
              this.coupon = { ...this.coupon, ...payload }
            },
            resetFields(){
              this.payments = []
              this.paymentsNext = []
              this.resumen = {
                    items: {
                        subtotal: { title: 'Subtotal', items: [], monto: 0 },
                        scholarships: { title: 'Becas', items: [], monto: 0 },
                        benefits: { title: 'Beneficios', items: [], monto: 0 },
                        discounts: { title: 'Descuentos', items: [], monto: 0 },
                        repayments: { title: 'Subtotal', items: [], monto: 0 },
                        adminExpenses: { title: 'Gastos Administrativos', items: [], monto: 0 },
                    },
                    cards: [
                        { paymentId: null, amount: null },
                        { paymentId: null, amount: null },
                    ],
                    total: 0,
                    tea: '0,00%',
                    cft: '0,00%',
                    paymentIntent: 0
              }
              this.allItemsResumen = {
                  items: {
                    subtotal: { title: 'Subtotal', items: [], monto: 0 },
                    scholarships: { title: 'Becas', items: [], monto: 0 },
                    benefits: { title: 'Beneficios', items: [], monto: 0 },
                    discounts: { title: 'Descuentos', items: [], monto: 0 },
                    repayments: { title: 'Subtotal', items: [], monto: 0 },
                    adminExpenses: { title: 'Gastos Administrativos', items: [], monto: 0 },
                  },
                  cards: [
                    { paymentId: null, amount: null },
                    { paymentId: null, amount: null },
                  ],
                  total: 0,
                  tea: '0,00%',
                  cft: '0,00%',
                  paymentIntent: 0
                }
            },
            async handleStudentCareerUpdate(value){
              this.selectedRegister = value
            }
        },
        watch: {
            selectedMethod: {
                handler() {this.definePrimaryCallback()},
                deep: true
            },
            payments(newPayments){
              this.summaryButtons.primary.disabled = !newPayments.length
              this.summaryButtons.directDebit.disabled = !newPayments.length
            },
          async selectedRegister(newVal) {
            if (!newVal) return
            this.resetFields()
            await this.fetchData()
          }
        },
    };
</script>

<style lang="sass">
    @media screen and (min-width: 640px)
        .paymentStepper.v-stepper:not(.v-stepper--vertical) .v-stepper__label
            display: flex
</style>

<style scoped lang="sass">
  .redirect-message p
    font-size: 12px

  .stepper-col
    background: #ffff
    height: 100%

  .stepper
    background: transparent
    border: none
    box-shadow: none !important

  .stepper-step
    background: #ffff

  .stepper-header
    box-shadow: none
    overflow: hidden
    border: solid 1px #c1c1c1
    height: auto
    border-radius: 6px

  .v-stepper__step__step
    display: none !important


  #tabs-payment
    width: 100%
    border-radius: 0.25em

  ul
    margin: 0
    padding: 0
    list-style-type: none
    overflow: hidden
    white-space: nowrap

  li
    + li
      padding: 1em 3em 1em 3em

    background: #f1f7ff
    text-align: center
    font-size: 16px
    font-weight: bold
    color: #c7c7c7
    width: 33%
    padding: 1em 2em
    position: relative
    display: inline-block
    vertical-align: top

    &.active
      background: white
      color: #012169

      + li:before
        background: white

    &.active:before
      background: #ffff

    + li:before
      content: ''
      position: absolute
      top: 0em
      bottom: 0
      border-right: solid 2px #c1c1c1
      border-top: solid 2px #c1c1c1
      pointer-events: none
      box-sizing: border-box

      /* a shadow effect can be added too
      width: 3em
      transform: rotate(30deg) skewy(30deg)
      z-index: 1

    + li:before
      left: -2em

  @media only screen and (max-width: 600px)
    li, li + li
      padding: 1em
      font-size: 12px
      width: 30%

    li:nth-child(3)
      width: 40%
    .v-stepper--alt-labels .v-stepper__step
        flex-basis: 0px !important

</style>

<style scoped>

v-card {
  padding: 24px;
}

v-btn {
  margin-right: 8px;
}

.mt-4 {
  margin-top: 1.5rem;
}
</style>
